<template>
  <div>
    <div class="coin-info main-section">
      <div class="input-search pr" @click="isShowSearchBox(true)">
        <input
          type="text"
          :placeholder="$t('trading.search.searchCoin')"
          v-model="searchStr"
          @input="searchCoinList"
        />
        <img
          class="ab img"
          src="@/assets/images/components/trading/icon_select_arrow.png"
          alt="arrow-down"
        />
      </div>
      <div class="too-price">
        <Spinner v-if="isSocketConnecting || isDepthConnecting"/>
        <p v-else :class="['price', priceColor]">{{ price }}</p>        
        <div>
          <p>{{ $t("trading.search.24high") }}</p>
          <span>{{ formatNumberWithComma(symbolPriceInfo?.high) }}</span>
        </div>
        <div>
          <p>{{ $t("trading.search.24low") }}</p>
          <span>{{ formatNumberWithComma(symbolPriceInfo?.low) }}</span>
        </div>
        <div>
          <p>{{ $t("trading.search.24vol", { ticker }) }}</p>
          <span>{{ formatNumberWithComma(symbolPriceInfo?.volume) }} </span>
        </div>
      </div>

      <div class="coin-list-box" v-if="isShowSearch">
        <ul class="coin-list">
          <li v-for="item in coinList" :key="item" @click="changeSelectCoin(item)">
            <img class="coin-img" :src="getCoinIcon(item)" />
            <p>{{ item }}</p>
          </li>
        </ul>
        <button class="close-btn" @click="isShowSearchBox(false)">
          {{ $t("trading.common.close") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { throttle } from "lodash-es";
import { formatNumberWithComma } from "@/utils/order";
import { onMounted, onUnmounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import Spinner from "../common/spinner/Spinner.vue";

const store = useStore();
let timer;

const previousPrice = ref(null);
const price = ref("");
const priceColor = ref("white");
const ticker = ref("BTC");
const isShowSearch = ref(false);
const searchStr = ref("");
const storeTicker = computed(() => store.state.transact.ticker);
const coinCombo = ref([]);
const coinList = computed(() => {
  if (searchStr.value !== "") {
    const filterd = coinCombo.value.filter((v) => v.value.includes(searchStr.value));
    return filterd.map(item => item.value + "USDT");
  } else {
    return coinCombo.value.map(item => item.value + "USDT");
  }
});
const countryCode = computed(() => store.state.transact.countryCode);
const symbolPriceInfo = computed(() => store.state.transact.symbolPriceInfo);
const isSocketConnecting = computed(() => store.state.transact.isSocketConnecting);
const isDepthConnecting = computed(() => store.state.transact.isDepthConnecting);
const subscStatus = computed(() => store.state.userInfo.chartInfo.subsc_status);

const getCoinIcon = (coin) => {
  const symbol = coin.slice(0, -4);
  try {
    return require(`@/assets/images/coin_logos/${symbol.toLowerCase()}.png`);
  } catch {
    return require("@/assets/images/coin_logos/default_dark.png");
  }
};

const searchCoinList = () => {
  searchStr.value = searchStr.value.toUpperCase();
};
const changeSelectCoin = (coin) => {
  const symbol = coin.slice(0, -4);
  ticker.value = symbol.toUpperCase();
  store.commit("transact/setTicker", ticker.value);
  searchStr.value = ticker.value;
  isShowSearch.value = false;
};
const isShowSearchBox = (bool) => {
  isShowSearch.value = bool;
  if (bool) {
    searchStr.value = "";
  }
};
const updatePriceThrottled = throttle((newPrice) => {
  if (previousPrice.value !== null) {
    if (newPrice > previousPrice.value) {
      priceColor.value = "green";
    } else if (newPrice < previousPrice.value) {
      priceColor.value = "red";
    } else {
      priceColor.value = priceColor.value === "red" ? "red" : "green";
    }
  }

  previousPrice.value = newPrice;
  price.value = newPrice;
  store.commit("transact/setLastPrice", price.value);
}, 500);


const initSymbol = async () => {
  if (!countryCode.value || !storeTicker.value) return;

  await store.dispatch("transact/connectTradeSocket", {
    updatePriceThrottled
  });
  await store.dispatch("transact/connectDepthSocket");

  price.value = 0;
  searchStr.value = storeTicker.value;
  await store.dispatch("transact/getSymbolPrice");
};

watch([() => storeTicker.value, () => countryCode.value], initSymbol,{ immediate: true });


onMounted(async () => {
  // if (subscStatus.value == 203) {
  //   return;
  // }
  coinCombo.value = await store.dispatch("getCoinList/getCoinComboList");
  // console.log("내가선택한코인리스트",coinCombo.value);
  ticker.value = coinCombo.value[0]?.value;
  store.commit("transact/setTicker", ticker.value);
  await store.dispatch("transact/getSymbolPrice");
  timer = setInterval(() => {
    store.dispatch("transact/getSymbolPrice");
  }, 600000);
});
onUnmounted(async () => {
  store.commit("transact/setIsDepthConnecting",false);
  clearInterval(timer);
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/trading/common.scss";
@import  "@/assets/scss/components/trading/coinSearchView.scss";
</style>
